import Player from "@/components/LottiePlayer";
import { ArrowNarrowRightIcon } from '@heroicons/react/outline'
import Image from 'next/image';
import Link from 'next/link';

const incentives = [
  {
    name: 'Built by top experts',
    imageSrc: '/assets/icons/favorite-white.json',
    description: "Created by the leading open source experts that built <a href='https://ckan.org/' target='_blank' ><span>CKAN</span></a>, <a href='https://frictionlessdata.io/' target='_blank' ><span>Frictionless Data</span></a>, <a href='https://datahub.io/' target='_blank' ><span>DataHub.io</span></a>, <a href='https://portaljs.com' target='_blank'><span>PortalJS</span></a>, and  <a href='https://flowershow.app/' target='_blank'><span>Flowershow</span></a>.",
  },
  {
    name: 'Easy setup in three steps',
    imageSrc: '/assets/icons/api-white.json',
    description: "With just a few clicks, you can set up a professional-looking CKAN-based data portal that's ready to use in no time. No coding skills required.",
  },
  {
    name: 'Affordable',
    imageSrc: '/assets/icons/ewallet.json',
    description:
      "Designed specifically for organizations looking for an affordable, cost-effective solution.",
  },
]

export default function Incentives() {
  return (
    <div className="bg-[#2a3342] font-['Inter']">
      <div className="mx-auto w-full xl:max-w-7xl lg:max-w-4xl md:max-w-3xl flex pt-0 sm:pt-12 pb-16 sm:px-2 lg:px-4">
        <div className="mx-auto max-w-2xl px-4 lg:max-w-none">
          <div className="grid grid-cols-1 items-center gap-x-16 gap-y-10 lg:grid-cols-2" tabIndex={0}>
            <div>
              <p className="text-orange-400 font-bold mb-4 lg:mt-0 mt-4">
                MANAGE, PUBLISH, AND SHOWCASE OPEN DATA
              </p>
              <h2 className="medium-title" style={{ color: "white" }}>
                Perfect fusion of functionality and design
              </h2>
              <p className="mt-4 text-lg text-white">
                <a href="https://www.portaljs.com" className="underline text-orange-100" target="_blank">PortalJS Cloud</a> is our cutting-edge fusion of <a href="solutions/ckan" className="underline text-orange-100">CKAN&apos;s</a> robust backend capabilities and <a href="https://portaljs.com/" className="underline text-orange-100" target="_blank">PortalJS&apos;s</a> sleek,
                modern front-end design. <a href="https://portaljs.com/" className="underline text-orange-100" target="_blank">PortalJS</a> is a framework for rapidly building rich data portal frontends using a modern
                approach (also created by Datopian). We&apos;ve combined our extensive expertise in <Link href="/solutions/ckan" className="underline text-orange-100">CKAN</Link> with <a href="https://portaljs.com/" className="underline text-orange-100" target="_blank">PortalJS</a> to
                deliver a modern open data portal solution that&apos;s both easy to use and visually stunning.
              </p>
              <div className='flex flex-col xl:flex-row mt-8 gap-y-8 sm:gap-x-8 w-full  px-8 sm:px-0 mx-auto xl:max-w-4xl lg:max-w-3xl md:max-w-2xl max-w-sm'>
                <div className='btn-primary'><a href='https://portaljs.com' target="_blank">Learn more about PortalJS</a> <ArrowNarrowRightIcon className='w-12 h-6 mt-[0.2rem]' /></div>
                {/* <div className='hover:cursor-pointer inline-flex justify-center items-center py-3 px-7 text-base font-medium text-center text-maingray rounded-lg hover:bg-orange-600 hover:text-white bg-gray-100 hover:focus:ring-4 focus:ring-orange-600 shadow-sm no-underline caret-transparent' ><a href='https://portaljs.com' target="_blank">Learn more about PortalJS</a></div> */}
              </div>
            </div>
            <div className="">
              <Image width={640} height={360}
                src="/assets/images/layout/product.webp"
                alt="DataHub"
                className="object-cover object-center"
              />
            </div>
          </div>
          <div className="mt-24 grid grid-cols-1 gap-x-8 gap-y-10 lg:grid-cols-3">
            {incentives.map((incentive) => (
              <div key={incentive.name} className="sm:flex items-center lg:block" tabIndex={0}>
                <div className="sm:flex-shrink-0 flex justify-center">
                  <Player
                    autoplay
                    loop
                    src={incentive.imageSrc}
                    style={{ height: "4rem", width: "4rem" }}
                  />
                  {/* <img className="h-16 w-16" src={incentive.imageSrc} alt="" /> */}
                </div>
                <div className="mt-4 sm:ml-6 sm:mt-0 lg:ml-0 lg:mt-6">
                  <h3 className="mt-2 small-title text-white !text-center" style={{ color: "white" }}>{incentive.name}</h3>
                  <p className="mt-2 body-text dpwhite text-center" style={{ color: "white" }} dangerouslySetInnerHTML={{ __html: incentive.description }} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
